const DjangoTranslations = {
  install: function (Vue) {
    Vue.prototype.gettext = function (key) {
      if (!this.$store.state.translations[key]) {
        if (this.$store.state.node_env !== 'local') {
          console.warn(`Can't find translation for key '${key}'`);
        }
        return key;
      }
      return this.$store.state.translations[key];
    };
  },
};

export default DjangoTranslations;
